import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProfessionalLayout from "@/components/layout/ProfessionalLayout";
import api from "@/api";
import { toast } from "sonner";

const STATUS = { MATCHED: ["Rapproché", "bg-emerald-100 text-emerald-800"], TO_CONFIRM: ["À confirmer", "bg-amber-100 text-amber-800"], UNKNOWN: ["Hors Hana", "bg-slate-100 text-slate-600"] };

export default function HdjImportReview() {
  const { importId } = useParams();
  const [imp, setImp] = useState(null);
  const [choice, setChoice] = useState({});

  const load = useCallback(async () => {
    try { const { data } = await api.get(`/hdj/imports/${importId}`); setImp(data); }
    catch { toast.error("Import introuvable"); }
  }, [importId]);
  useEffect(() => { load(); }, [load]);

  const confirm = async (row, patientId) => {
    try {
      await api.post(`/hdj/imports/${importId}/rows/${row.index}/confirm`, { patientId: patientId || null });
      toast.success(patientId ? "Ligne appliquée" : "Ligne écartée");
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Action impossible"); }
  };

  if (!imp) return <ProfessionalLayout><div className="dash-card text-sm text-slate-500">Chargement…</div></ProfessionalLayout>;
  const label = imp.mode === "SEANCES_JOUR" ? "Séances HDJ du" : "RDV HDJ importés pour le";

  return (
    <ProfessionalLayout>
      <div className="space-y-4" data-testid="hdj-import-review-page">
        <div>
          <p className="text-sm text-emerald-700 font-semibold">Export secrétariat · {imp.extractor === "ai" ? "lu par IA" : "fichier"}</p>
          <h1 className="text-2xl font-bold text-slate-900">{label} {imp.targetDate}</h1>
          <p className="text-xs text-slate-500">{imp.fileName} · {imp.rows.length} ligne(s)</p>
        </div>
        <div className="dash-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-slate-500"><th className="py-2">Ligne export</th><th>Heure</th><th>Type</th><th>Statut</th><th>Patient Hana</th><th></th></tr></thead>
            <tbody>
              {imp.rows.map((r) => (
                <tr key={r.index} className="border-t border-slate-100" data-testid={`hdj-import-row-${r.index}`}>
                  <td className="py-2 font-medium text-slate-800">{r.lastName} {r.firstName}{r.birthDate ? <span className="text-slate-400 text-xs"> · {r.birthDate}</span> : null}</td>
                  <td>{r.time || "—"}</td><td>{r.type || "—"}</td>
                  <td><span className={`text-xs px-2 py-0.5 rounded-full ${STATUS[r.matchStatus][1]}`}>{r.ignored ? "Écartée" : r.applied ? `Appliquée (${r.result?.action})` : STATUS[r.matchStatus][0]}</span></td>
                  <td>
                    {r.applied || r.ignored ? (r.candidates?.find((c) => c.patientId === r.patientId)?.name || (r.patientId ? "confirmé" : "—")) : r.matchStatus === "UNKNOWN" ? <span className="text-xs text-slate-400">aucun candidat</span> : (
                      <select value={choice[r.index] ?? r.candidates?.[0]?.patientId ?? ""} onChange={(e) => setChoice({ ...choice, [r.index]: e.target.value })} data-testid={`hdj-import-candidate-${r.index}`} className="border rounded-lg px-2 py-1 text-sm">
                        {r.candidates.map((c) => <option key={c.patientId} value={c.patientId}>{c.name} ({Math.round(c.score * 100)} %)</option>)}
                      </select>
                    )}
                  </td>
                  <td className="text-right whitespace-nowrap">
                    {!r.applied && !r.ignored && r.matchStatus !== "UNKNOWN" && (
                      <>
                        <button onClick={() => confirm(r, choice[r.index] ?? r.candidates?.[0]?.patientId)} data-testid={`hdj-import-confirm-${r.index}`} className="text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-2.5 py-1 mr-1">Confirmer</button>
                        <button onClick={() => confirm(r, null)} data-testid={`hdj-import-ignore-${r.index}`} className="text-xs font-semibold text-slate-600 bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-1">Écarter</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ProfessionalLayout>
  );
}
